import { useEffect, useState } from "react"

import { SiriOrb } from "@/components/ui/siri-orb"
import { useAssistant } from "@/hooks/use-assistant"
import { cn } from "@/lib/utils"

// IMP-461: every setup opens with an automatic building beat — the assistant
// builds the agent from the business profile while the status lines progress,
// then the flow advances on its own. No continue press.
export function BuildingBeat({
  title,
  lines,
  onDone,
}: {
  title: string
  lines: string[]
  onDone: () => void
}) {
  const [line, setLine] = useState(0)
  const { theme } = useAssistant()

  useEffect(() => {
    if (line >= lines.length - 1) {
      const t = setTimeout(onDone, 900)
      return () => clearTimeout(t)
    }
    const t = setTimeout(() => setLine((n) => n + 1), 1100)
    return () => clearTimeout(t)
  }, [line, lines.length, onDone])

  return (
    <div className="h-app-viewport flex flex-col items-center justify-center gap-8 px-6">
      <SiriOrb size={140} colors={theme.colors} className="drop-shadow-xl" />
      <div className="space-y-2 text-center">
        <h1 className="text-xl font-semibold">{title}</h1>
        <div className="space-y-1.5 pt-2">
          {lines.slice(0, line + 1).map((l, i) => (
            <p
              key={l}
              className={cn(
                "animate-in fade-in text-sm duration-300",
                i === line ? "text-foreground" : "text-muted-foreground",
              )}
            >
              {l}
            </p>
          ))}
        </div>
      </div>
    </div>
  )
}
